import * as React from 'react';
export const spardaSvg = React.forwardRef(function spardaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EBF1F7',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          fillRule: 'nonzero',
        },
        /*#__PURE__*/ React.createElement('path', {
          fill: '#F46F21',
          d: 'M0 24.73h32V32H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#0066B4',
          d: 'M0 0h32v23.27H0z',
        }),
        /*#__PURE__*/ React.createElement('path', {
          fill: '#FFF',
          d: 'M28.26 18.73v.47c0 .28-.06.36-.17.36-.12 0-.15-.07-.15-.27v-1.82c0-.95-.48-1.31-1.67-1.31-.98 0-1.5.35-1.5 1.03 0 .4.26.69.6.69.32 0 .55-.25.55-.59 0-.21-.12-.34-.35-.46.13-.07.29-.1.44-.09.54 0 .84.22.84.61 0 .35-.14.5-.7.63l-.14.03-.15.03-.14.04-.48.15c-.4.14-.6.5-.6 1.01 0 .66.4 1.08 1.08 1.08.46 0 .85-.22 1.16-.61.15.44.44.61.93.61.64 0 .95-.36.95-1.12v-.47h-.5zm-2.1.82c-.25 0-.43-.18-.43-.45 0-.3.12-.4.5-.53l.6-.23v.61c0 .3-.31.6-.66.6zm-4.1-4.83v.65h.33c.18 0 .26.1.26.37v.97c-.35-.43-.61-.56-1.02-.56-.93 0-1.57.9-1.57 2.18 0 1.2.6 1.99 1.54 1.99.45.02.88-.2 1.13-.58v.43h1.6v-.65h-.29c-.2 0-.27-.1-.27-.38v-4.42h-1.7zm.66 3.52c0 .83-.3 1.38-.77 1.38-.47 0-.71-.46-.71-1.3 0-.87.29-1.37.75-1.37.47 0 .73.48.73 1.3v-.01zm-6.21-1.98v.67h.33c.2 0 .27.1.27.36v1.85c0 .28-.06.38-.27.38h-.33v.65h2.4v-.65h-.44c-.19 0-.26-.1-.26-.38v-.97c0-.85.3-1.43.7-1.43-.15.22-.2.34-.2.48 0 .34.23.58.53.58.38 0 .61-.29.61-.74 0-.52-.29-.87-.72-.87-.38 0-.58.13-.95.65l.03-.58h-1.7zm-.61 2.47v.47c0 .28-.05.36-.18.36-.1 0-.14-.07-.14-.27v-1.82c0-.95-.48-1.31-1.66-1.31-.99 0-1.51.35-1.51 1.03 0 .4.26.69.6.69.31 0 .55-.25.55-.59 0-.21-.12-.34-.34-.46.13-.07.29-.1.44-.09.52 0 .83.22.83.61 0 .35-.15.5-.69.63l-.14.03-.15.03-.14.04c-.2.04-.37.1-.48.15-.4.14-.61.5-.61 1.01 0 .66.4 1.08 1.07 1.08.47 0 .88-.22 1.17-.61.14.44.43.61.94.61.64 0 .93-.36.93-1.12v-.47h-.5zm-2.1.82c-.24 0-.42-.18-.42-.45 0-.3.1-.4.48-.53l.61-.23v.61c0 .3-.32.6-.67.6zm-6.27-3.29v.67h.3c.21 0 .29.1.29.36v3.5c0 .27-.08.36-.3.36h-.29v.67h2.3v-.67h-.35c-.2 0-.27-.09-.27-.36v-.96c.29.33.6.49 1.02.49 1.01 0 1.57-.79 1.57-2.23 0-1.2-.56-1.94-1.47-1.94-.46-.02-.9.2-1.14.6l.02-.49H7.53zm3.09 1.92c0 .9-.25 1.38-.71 1.38-.47 0-.72-.42-.72-1.3 0-.86.26-1.34.73-1.34.45 0 .7.45.7 1.26zM6.5 14.72l-.1.36a2 2 0 0 0-1.45-.53c-1.24 0-2.03.7-2.03 1.81 0 .41.1.73.3 1.02.21.26.52.42 1.17.58l.25.08.25.05.26.06.67.2c.25.1.35.25.35.5 0 .44-.37.73-.95.73-.54 0-1.07-.25-1.3-.61a2.07 2.07 0 0 1-.3-.82h-.71v2.04h.58l.16-.45c.47.42.98.6 1.69.6 1.22 0 1.95-.69 1.95-1.84 0-.67-.26-1.12-.79-1.38-.48-.2-.98-.34-1.5-.44-.78-.16-1-.32-1-.68 0-.44.39-.74.94-.74.83 0 1.37.52 1.47 1.42h.7v-1.96h-.6z',
        }),
      ),
    ),
  );
});
spardaSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var sparda = {
  category: 'brand',
  colorable: false,
  name: 'sparda',
  svg: spardaSvg,
};
